import { memo } from "react"

export const Spinner = memo(() => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="animate-spin">
    <path d="M21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21" stroke="#505A78" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
))
